
import { PayoutType } from './payout.type';

const INITIAL_STATE = {
    transferTotalAmount: '',
    surcharge: '',
    orderId: '',
    amount: '',
    createOrderReq: '',
    createOrderRes: '',
    createOrderStatusResponse: '',
    createOrderResponseDetails: '',
    moneyTransferProgress: '',
    formDate: '',
    toDate: '',
    merchantData:''
};

const payoutReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PayoutType.setMoneyTransferTotalAmount:
            return {
                ...state,
                transferTotalAmount: action.payload,
            };

        case PayoutType.setMoneyTransferSurChargeAmount:
            return {
                ...state,
                surcharge: action.payload,
            };

        case PayoutType.showCreateOrderResponse:
            return {
                ...state,
                createdOrderResponse: action.payload,
            };

        case PayoutType.setOrderId:
            return {
                ...state,
                orderId: action.payload,
            };
        case PayoutType.setMoneyTransferTotalAmount:
            return {
                ...state,
                transferTotalAmount: action.payload,
            };

        case PayoutType.setMoneyTransferSurChargeAmount:
            return {
                ...state,
                surcharge: action.payload,
            };
        case PayoutType.setAmount:
            return {
                ...state,
                amount: action.payload,
            };
        case PayoutType.setStatusEnqResponse:
            return {
                ...state,
                createOrderStatusResponse: action.payload,
            };

        case PayoutType.setCreteOrderReq:
            return {
                ...state,
                createOrderReq: action.payload,
            };

        case PayoutType.setCreateOrderRes:
            return {
                ...state,
                createOrderRes: action.payload,
            };

        case PayoutType.setMoneyTransferProgress:
            return {
                ...state,
                moneyTransferProgress: action.payload,
            };
        case PayoutType.setMerchantDetails:
            return {
                ...state,
                merchantData: action.payload,
            };
        case PayoutType.setFilterEndDate:
            return {
                ...state,
                toDate: action.payload,
            };
        case PayoutType.setFilterStartDate:
            return {
                ...state,
                formDate: action.payload,
            };

        case PayoutType.RESET:
            return INITIAL_STATE;
        default:
            return state;
    }

};

export default payoutReducer; 